import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import useStore from '../../store'

export default function TaskList({ phaseId, goalId }) {
  const tasks      = useStore(s => s.tasks.filter(t => t.phase_id === phaseId))
  const createTask = useStore(s => s.createTask)
  const toggleTask = useStore(s => s.toggleTask)
  const deleteTask = useStore(s => s.deleteTask)

  const [adding,   setAdding]   = useState(false)
  const [title,    setTitle]    = useState('')
  const [hrs,      setHrs]      = useState('')

  const handleAdd = async () => {
    if (!title.trim()) return
    await createTask(phaseId, goalId, {
      title:           title.trim(),
      estimated_hours: hrs ? Number(hrs) : null,
    })
    setTitle(''); setHrs(''); setAdding(false)
  }

  const done  = tasks.filter(t => t.status === 'completed').length
  const total = tasks.length

  return (
    <div className="flex flex-col gap-1.5">

      {/* Progress line */}
      {total > 0 && (
        <div className="flex items-center gap-2 mb-1">
          <div className="flex-1 h-px bg-m-muted relative overflow-hidden">
            <div className="absolute inset-y-0 left-0 bg-m-accent transition-all duration-300"
              style={{ width: `${total ? (done / total) * 100 : 0}%` }} />
          </div>
          <span className="font-mono text-[9px] text-m-faint">{done}/{total}</span>
        </div>
      )}

      {/* Task rows */}
      <AnimatePresence>
        {tasks.map(task => (
          <motion.div key={task.id} layout
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className={`flex items-center gap-2 group ${task.status === 'completed' ? 'opacity-40' : ''}`}
          >
            {/* Checkbox */}
            <button
              onClick={() => toggleTask(task.id)}
              className={`w-3.5 h-3.5 shrink-0 border flex items-center justify-center transition-colors ${
                task.status === 'completed'
                  ? 'border-m-accent bg-m-accent/20'
                  : 'border-m-faint hover:border-m-subtle'
              }`}
            >
              {task.status === 'completed' && (
                <div className="w-1.5 h-1.5 bg-m-accent" />
              )}
            </button>

            <span className={`font-mono text-xs flex-1 min-w-0 truncate ${
              task.status === 'completed' ? 'line-through text-m-faint' : 'text-m-text'
            }`}>
              {task.title}
            </span>

            {task.estimated_hours && (
              <span className="font-mono text-[10px] text-m-faint shrink-0">{task.estimated_hours}h</span>
            )}

            <button
              onClick={() => deleteTask(task.id)}
              className="font-mono text-[10px] text-m-faint opacity-0 group-hover:opacity-100 hover:text-m-danger transition-all leading-none"
            >
              ×
            </button>
          </motion.div>
        ))}
      </AnimatePresence>

      {/* Add row */}
      {adding ? (
        <div className="flex items-center gap-1.5 mt-1">
          <input
            autoFocus
            className="input-sm flex-1 text-xs"
            placeholder="Task title"
            value={title}
            onChange={e => setTitle(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') handleAdd(); if (e.key === 'Escape') setAdding(false) }}
          />
          <input
            type="number" min="0.5" step="0.5"
            className="input-sm w-14 text-xs text-right"
            placeholder="hrs"
            value={hrs}
            onChange={e => setHrs(e.target.value)}
          />
          <button onClick={handleAdd} className="btn-primary btn-sm py-1 px-2">+</button>
          <button onClick={() => { setAdding(false); setTitle(''); setHrs('') }}
            className="font-mono text-xs text-m-faint hover:text-m-subtle">×</button>
        </div>
      ) : (
        <button
          onClick={() => setAdding(true)}
          className="font-mono text-[10px] text-m-faint hover:text-m-subtle transition-colors text-left mt-0.5"
        >
          + Add task
        </button>
      )}
    </div>
  )
}
